import React from 'react';

import { Box } from '@mui/material';

const popupMessageRenderer = (popupMessage: string) => {
  return <Box dangerouslySetInnerHTML={{ __html: popupMessage }} />;
};

export default popupMessageRenderer;
